module.exports = coreApis.observer;